// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file trade/v1/salesOrder_events.proto (package trade.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { SalesOrder, SalesOrderStatus } from "./salesOrder_pb.js";
import { file_trade_v1_salesOrder } from "./salesOrder_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file trade/v1/salesOrder_events.proto.
 */
export const file_trade_v1_salesOrder_events: GenFile = /*@__PURE__*/
  fileDesc("CiB0cmFkZS92MS9zYWxlc09yZGVyX2V2ZW50cy5wcm90bxIIdHJhZGUudjEi3AIKD1NhbGVzT3JkZXJFdmVudBIzCgdjcmVhdGVkGAEgASgLMiAudHJhZGUudjEuU2FsZXNPcmRlckNyZWF0ZWRFdmVudEgAEjMKB3VwZGF0ZWQYAiABKAsyIC50cmFkZS52MS5TYWxlc09yZGVyVXBkYXRlZEV2ZW50SAASMwoHZGVsZXRlZBgDIAEoCzIgLnRyYWRlLnYxLlNhbGVzT3JkZXJEZWxldGVkRXZlbnRIABIxCgZvcGVuZWQYBSABKAsyHy50cmFkZS52MS5TYWxlc09yZGVyT3BlbmVkRXZlbnRIABI1CghmaW5pc2hlZBgGIAEoCzIhLnRyYWRlLnYxLlNhbGVzT3JkZXJGaW5pc2hlZEV2ZW50SAASMQoGdm9pZGVkGAcgASgLMh8udHJhZGUudjEuU2FsZXNPcmRlclZvaWRlZEV2ZW50SABCBwoFZXZlbnRKBAgEEAUiQwoWU2FsZXNPcmRlckNyZWF0ZWRFdmVudBIpCgtzYWxlc19vcmRlchgBIAEoCzIULnRyYWRlLnYxLlNhbGVzT3JkZXIifwoWU2FsZXNPcmRlclVwZGF0ZWRFdmVudBIyChRwcmV2aW91c19zYWxlc19vcmRlchgBIAEoCzIULnRyYWRlLnYxLlNhbGVzT3JkZXISMQoTdXBkYXRlZF9zYWxlc19vcmRlchgCIAEoCzIULnRyYWRlLnYxLlNhbGVzT3JkZXIiQwoWU2FsZXNPcmRlckRlbGV0ZWRFdmVudBIpCgtzYWxlc19vcmRlchgBIAEoCzIULnRyYWRlLnYxLlNhbGVzT3JkZXIidwoVU2FsZXNPcmRlck9wZW5lZEV2ZW50EikKC3NhbGVzX29yZGVyGAEgASgLMhQudHJhZGUudjEuU2FsZXNPcmRlchIzCg9wcmV2aW91c19zdGF0dXMYAiABKA4yGi50cmFkZS52MS5TYWxlc09yZGVyU3RhdHVzInkKF1NhbGVzT3JkZXJGaW5pc2hlZEV2ZW50EikKC3NhbGVzX29yZGVyGAEgASgLMhQudHJhZGUudjEuU2FsZXNPcmRlchIzCg9wcmV2aW91c19zdGF0dXMYAiABKA4yGi50cmFkZS52MS5TYWxlc09yZGVyU3RhdHVzIncKFVNhbGVzT3JkZXJWb2lkZWRFdmVudBIpCgtzYWxlc19vcmRlchgBIAEoCzIULnRyYWRlLnYxLlNhbGVzT3JkZXISMwoPcHJldmlvdXNfc3RhdHVzGAIgASgOMhoudHJhZGUudjEuU2FsZXNPcmRlclN0YXR1c0IvWi1wYWNrYWdlcy9iYWNrZW5kLW1vZHVsZS10cmFkZS9hcGkvdjE7dHJhZGVfdjFiCGVkaXRpb25zcOgH", [file_trade_v1_salesOrder]);

/**
 * @generated from message trade.v1.SalesOrderEvent
 */
export type SalesOrderEvent = Message<"trade.v1.SalesOrderEvent"> & {
  /**
   * @generated from oneof trade.v1.SalesOrderEvent.event
   */
  event: {
    /**
     * @generated from field: trade.v1.SalesOrderCreatedEvent created = 1;
     */
    value: SalesOrderCreatedEvent;
    case: "created";
  } | {
    /**
     * @generated from field: trade.v1.SalesOrderUpdatedEvent updated = 2;
     */
    value: SalesOrderUpdatedEvent;
    case: "updated";
  } | {
    /**
     * @generated from field: trade.v1.SalesOrderDeletedEvent deleted = 3;
     */
    value: SalesOrderDeletedEvent;
    case: "deleted";
  } | {
    /**
     * @generated from field: trade.v1.SalesOrderOpenedEvent opened = 5;
     */
    value: SalesOrderOpenedEvent;
    case: "opened";
  } | {
    /**
     * @generated from field: trade.v1.SalesOrderFinishedEvent finished = 6;
     */
    value: SalesOrderFinishedEvent;
    case: "finished";
  } | {
    /**
     * @generated from field: trade.v1.SalesOrderVoidedEvent voided = 7;
     */
    value: SalesOrderVoidedEvent;
    case: "voided";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message trade.v1.SalesOrderEvent.
 * Use `create(SalesOrderEventSchema)` to create a new message.
 */
export const SalesOrderEventSchema: GenMessage<SalesOrderEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder_events, 0);

/**
 * @generated from message trade.v1.SalesOrderCreatedEvent
 */
export type SalesOrderCreatedEvent = Message<"trade.v1.SalesOrderCreatedEvent"> & {
  /**
   * @generated from field: trade.v1.SalesOrder sales_order = 1;
   */
  salesOrder?: SalesOrder;
};

/**
 * Describes the message trade.v1.SalesOrderCreatedEvent.
 * Use `create(SalesOrderCreatedEventSchema)` to create a new message.
 */
export const SalesOrderCreatedEventSchema: GenMessage<SalesOrderCreatedEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder_events, 1);

/**
 * @generated from message trade.v1.SalesOrderUpdatedEvent
 */
export type SalesOrderUpdatedEvent = Message<"trade.v1.SalesOrderUpdatedEvent"> & {
  /**
   * @generated from field: trade.v1.SalesOrder previous_sales_order = 1;
   */
  previousSalesOrder?: SalesOrder;

  /**
   * @generated from field: trade.v1.SalesOrder updated_sales_order = 2;
   */
  updatedSalesOrder?: SalesOrder;
};

/**
 * Describes the message trade.v1.SalesOrderUpdatedEvent.
 * Use `create(SalesOrderUpdatedEventSchema)` to create a new message.
 */
export const SalesOrderUpdatedEventSchema: GenMessage<SalesOrderUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder_events, 2);

/**
 * @generated from message trade.v1.SalesOrderDeletedEvent
 */
export type SalesOrderDeletedEvent = Message<"trade.v1.SalesOrderDeletedEvent"> & {
  /**
   * @generated from field: trade.v1.SalesOrder sales_order = 1;
   */
  salesOrder?: SalesOrder;
};

/**
 * Describes the message trade.v1.SalesOrderDeletedEvent.
 * Use `create(SalesOrderDeletedEventSchema)` to create a new message.
 */
export const SalesOrderDeletedEventSchema: GenMessage<SalesOrderDeletedEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder_events, 3);

/**
 * @generated from message trade.v1.SalesOrderOpenedEvent
 */
export type SalesOrderOpenedEvent = Message<"trade.v1.SalesOrderOpenedEvent"> & {
  /**
   * @generated from field: trade.v1.SalesOrder sales_order = 1;
   */
  salesOrder?: SalesOrder;

  /**
   * @generated from field: trade.v1.SalesOrderStatus previous_status = 2;
   */
  previousStatus: SalesOrderStatus;
};

/**
 * Describes the message trade.v1.SalesOrderOpenedEvent.
 * Use `create(SalesOrderOpenedEventSchema)` to create a new message.
 */
export const SalesOrderOpenedEventSchema: GenMessage<SalesOrderOpenedEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder_events, 4);

/**
 * @generated from message trade.v1.SalesOrderFinishedEvent
 */
export type SalesOrderFinishedEvent = Message<"trade.v1.SalesOrderFinishedEvent"> & {
  /**
   * @generated from field: trade.v1.SalesOrder sales_order = 1;
   */
  salesOrder?: SalesOrder;

  /**
   * @generated from field: trade.v1.SalesOrderStatus previous_status = 2;
   */
  previousStatus: SalesOrderStatus;
};

/**
 * Describes the message trade.v1.SalesOrderFinishedEvent.
 * Use `create(SalesOrderFinishedEventSchema)` to create a new message.
 */
export const SalesOrderFinishedEventSchema: GenMessage<SalesOrderFinishedEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder_events, 5);

/**
 * @generated from message trade.v1.SalesOrderVoidedEvent
 */
export type SalesOrderVoidedEvent = Message<"trade.v1.SalesOrderVoidedEvent"> & {
  /**
   * @generated from field: trade.v1.SalesOrder sales_order = 1;
   */
  salesOrder?: SalesOrder;

  /**
   * @generated from field: trade.v1.SalesOrderStatus previous_status = 2;
   */
  previousStatus: SalesOrderStatus;
};

/**
 * Describes the message trade.v1.SalesOrderVoidedEvent.
 * Use `create(SalesOrderVoidedEventSchema)` to create a new message.
 */
export const SalesOrderVoidedEventSchema: GenMessage<SalesOrderVoidedEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder_events, 6);

